import { BaseClient } from '../../lib';
export class CreditsClient extends BaseClient {
    url;
    constructor(url, config) {
        super(url, config);
        this.url = url;
    }
    /**
     * Fetches the credits for a user
     * @param address - The user's address
     * @returns The credits for the user
     */
    async fetchCredits(address) {
        try {
            const response = await this.fetch(`/users/${address}/credits`);
            return response;
        }
        catch (error) {
            console.error('Error fetching credits', error);
            return { credits: [], totalCredits: 0 };
        }
    }
    createSSEConnection(address, onMessage, onError) {
        const eventSource = new EventSource(`${this.url}/users/${address}/credits/stream`);
        eventSource.onmessage = event => {
            try {
                const data = JSON.parse(event.data);
                onMessage(data);
            }
            catch (error) {
                console.error('Error parsing SSE event data:', error);
            }
        };
        eventSource.onerror = error => {
            console.error('SSE connection error:', error);
            onError(error);
        };
        return eventSource;
    }
}
//# sourceMappingURL=CreditsClient.js.map